import Overlay from './overlay';
import { featureCollectionToTurfPolygons } from './createTurfPolygons';

class LabelManager {
    constructor() {
        this.overlayLabels = null;
        this.salesDistrictsOverlay = null;
    }

    handleLabels({ map, maps, turfPolygons, selectionType, isSalesDistricts, salesDistricts }) {
        if (!turfPolygons[selectionType]) return;
        
        this.overlayLabels = Overlay({ 
            polygons: turfPolygons[selectionType], 
            map, 
            maps
        });

        if (isSalesDistricts && salesDistricts) {
            this.salesDistrictsOverlay = Overlay({ 
                polygons: featureCollectionToTurfPolygons(salesDistricts), 
                map, 
                maps,
                ignoreArea: true,
                modifiers: {
                    'overlay-label--districts': true
                }
            });
        }
    }

    removeAllLabels() {
        if (this.overlayLabels) {
            this.overlayLabels.remove();
        }
        if (this.salesDistrictsOverlay) {
            this.salesDistrictsOverlay.setMap(null);
            this.salesDistrictsOverlay = null;
        }
    }
}

export default LabelManager; 